enum CheckItemTypeEnum {
  TX = 'tx',
  ADDRESS = 'addr',
}

export { CheckItemTypeEnum };
